export function usersCanSeeEachOther(currentUser, otherUser) {
  if (!currentUser || !otherUser || currentUser.id === otherUser.id) {
    return false;
  }

  const currentContactIds = currentUser.contactIds || [];
  const otherContactIds = otherUser.contactIds || [];
  if (currentContactIds.includes(otherUser.id) || otherContactIds.includes(currentUser.id)) {
    return true;
  }

  const currentTeamIds = currentUser.teamIds || [];
  const otherTeamIds = otherUser.teamIds || [];
  if (currentTeamIds.length > 0 && otherTeamIds.length > 0) {
    return otherTeamIds.some(teamId => currentTeamIds.includes(teamId));
  }

  return false;
}
